import React, { useState } from 'react'
import { Button as MaterialUIButton } from '@material-ui/core'
import { postProccessOk } from '@auteco/services/gdcServices'
import { getPermissions } from '@auteco/utils/Common'
import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import { PlansList } from './components/PlansList'
import Button from '../../sharedComponents/CustomButtons/Button'
import { useStyles } from './styles'
import { FinancialModel } from './components/FinancialModel'
import { Alert } from '../Alert'

const DetailedPlan = ({ selectOption, onCloseOption }) => {
    const [alertInfo, setAlertInfo] = useState({ open: false, onClose: () => { }, title: '', content: '', onlyButton: false, btn1Txt: '', btn2Txt: '', btn1Func: () => { }, btn2Func: () => { } })
    const classes = useStyles()

    const permissions = getPermissions()

    const sendDetailedPlan = async () => {
        const body = {
            paso: 3,
            solicitante: selectOption.solicitante
        }
        const response = await postProccessOk({ params: body })
        if (response.success === 1) {
            setAlertInfo({ ...alertInfo, open: false })
            onCloseOption()
        }
    }
    const finishDetailedPlan = async () => {
        setAlertInfo(
            {
                open: true,
                onClose: () => setAlertInfo({ ...alertInfo, open: false }),
                title: '!Espera!',
                content: '¿Estás seguro de que deseas terminar este proceso?',
                onlyButton: false,
                btn1Txt: 'Aceptar',
                btn2Txt: 'Cancelar',
                btn1Func: () => sendDetailedPlan(),
                btn2Func: () => setAlertInfo({ ...alertInfo, open: false })
            })
    }
    return (
        <>
            <Alert info={alertInfo} />
            <section>
                <Card>
                    <CardBody>
                        <CardTitle
                            title='Plan  detallado'
                            subTitle={`${selectOption.razon_social} -  ${selectOption.solicitante}`}
                        />
                        <Button onClick={onCloseOption}>Volver</Button>
                    </CardBody>
                    <div className={classes.gridContainer}>
                        <div className={classes.gridItem}>
                            <PlansList
                                partner={selectOption.solicitante}
                                companyName={selectOption.razon_social}
                                nit={selectOption.nit}
                                isEnabled={selectOption.isEnabled}
                            />
                        </div>
                        <div className={classes.gridItem}>
                            <FinancialModel partner={selectOption.solicitante} isEnabled={selectOption.isEnabled} />
                        </div>
                    </div>
                    {permissions[58] === 5 &&
                        <MaterialUIButton
                            variant='contained'
                            color='primary'
                            className={classes.finishBtn}
                            disabled={!selectOption?.isEnabled}
                            onClick={finishDetailedPlan}
                        >
                            Finalizado
                        </MaterialUIButton>
                    }
                </Card>
            </section>
        </>
    )
}

export { DetailedPlan }